module.exports = __webpack_public_path__ + "static/img/background.74d485e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background.png
// module id = cf+J
// module chunks = 1